import axios from "axios";
import Vue from "vue";

axios.defaults.baseURL = "/api/v1";
axios.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("access_token");

axios.interceptors.response.use(
    (response) => {
        let responseData = response?.data;
        if (
            typeof responseData === "string" ||
            responseData instanceof String
        ) {
            if (response?.data.startsWith("\\")) {
                responseData = JSON.parse(responseData.substring(1));
            } else {
                responseData = JSON.parse(responseData);
            }
        }
        // Show success message
        if (responseData?.message) {
            const success = responseData?.success;
            Vue.notify({
                title: lang.get(success ? "form.success" : "form.error"),
                type: success ? "success" : "error",
                text: responseData.message,
                duration: 5000,
            });
        }
        return Promise.resolve({
            ...response,
            data: responseData,
        });
    },
    (error) => {
        let errorData = error?.response?.data;
        if (typeof errorData === "string" || errorData instanceof String) {
            if (error?.response?.data.startsWith("\\")) {
                errorData = JSON.parse(errorData.substring(1));
            } else {
                errorData = JSON.parse(errorData);
            }
        }
        if (error?.response?.status === 422) {
            // Show error message
            const { errors } = errorData;
            const keys = Object.keys(errors);
            const message = errors[keys[0]] ? errors[keys[0]][0] : "";
            if (message) {
                Vue.notify({
                    title: lang.get("form.error"),
                    type: "error",
                    text: message,
                    duration: 5000,
                });
            }
        } else if (error?.response?.status === 401 && window.location.pathname !== "/login") {
            localStorage.removeItem("access_token");
            localStorage.removeItem("pathToLoadAfterLogin");
            delete axios.defaults.headers.common["Authorization"];
            window.location.href = "/login";         
        } else if (errorData?.message) {
            Vue.notify({
                title: lang.get("form.error"),
                type: "error",
                text: errorData.message,
                duration: 5000,
            });
        }

        return Promise.reject({
            ...error,
            response: {
                ...error?.response,
                data: errorData,
            },
        });
    }
);
